<div class="layer-panel">
  <nb-actions size="small" class="">
    <nb-action class="control-button" (click)="onGoHomeButtonClicked()" [nbPopover]="'Go Home' | translate" nbPopoverTrigger="hint" nbPopoverPlacement="top">
      <div class="icon-container">
        <uruk-svg
          [paths]="[
                'M0 0H40V40H0V0Z',
                'M9 16V10C9 9.44772 9.44772 9 10 9H16',
                'M31 16V10C31 9.44772 30.5523 9 30 9H24',
                'M9 24V30C9 30.5523 9.44772 31 10 31H16',
                'M31 24V30C31 30.5523 30.5523 31 30 31H24'
              ]"
          [svgContainerClass]="'uruk-icon'"
          [svgContainerStyle]="'width: 2vw; height: 2vw;'"
          [viewbox]="'0 0 40 40'"
          [fills]="['#242525', 'none', 'none', 'none', 'none']"
          [strokes]="[null, '#C9C9C9', '#C9C9C9', '#C9C9C9', '#C9C9C9']"
          [strokeWidths]="[null, 2, 2, 2, 2]">
        </uruk-svg>
      </div>
    </nb-action>
    <nb-action class="control-button" (click)="onZoomInClicked()" [nbPopover]="'Zoom In' | translate" nbPopoverTrigger="hint" nbPopoverPlacement="top">
      <div class="icon-container"><i class="control-icon fa fa-plus fa-lg"></i></div>
    </nb-action>

    <nb-action class="control-button" (click)="onZoomOutClicked()" [nbPopover]="'Zoom Out' | translate" nbPopoverTrigger="hint" nbPopoverPlacement="top">
      <div class="icon-container"><i class="control-icon fa fa-minus fa-lg"></i></div>
    </nb-action>
  </nb-actions>
</div>
